<template>
  <div>
    <v-dialog v-model="show" max-width="700" persistent>
      <v-card>
        <v-card-title class="justify-center">
          <v-icon left color="blue">mdi-format-list-checkbox</v-icon>
          Lista de atividades {{ anoEscolar.descricao }} {{ anoEscolar.disciplina }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-alert :value="success" dense text type="success">
                Atividade(s) deletada(s) com <strong>sucesso!</strong>
              </v-alert>

              <v-alert :value="error" dense outlined type="error">
                <strong>Erro</strong> ao deletar a(s) atividade(s)!
              </v-alert>
            </v-col>
          </v-row>
          <v-data-table fixed-header height="500" v-model='atividadesSelecionadas' :headers='headers'
            :items='atividades' :loading='carregandoDados' :footer-props="footerProps" :search="search"
            no-data-text="Nenhuma atividade encontra" item-key='id' show-select class='elevation-1'>
            <template v-slot:top>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="search" label="Pesquise" outlined dense></v-text-field>
                </v-col>
                <v-col cols="3">
                  <!-- <v-btn
                       :disabled="atividadesSelecionadas.length < 2"
                      color="red"
                      class="white--text"
                      @click="deletarMultiplos()"
                  >
                    <v-icon left dark>
                      mdi-close-circle
                    </v-icon>
                    REMOVER
                  </v-btn>-->
                </v-col>
                <v-col cols="3">
                  <v-btn :disabled="atividadesSelecionadas.length < 2" color="orange" class="white--text"
                    @click="visualizarTodos()">
                    <v-icon left dark>
                      mdi-file-pdf
                    </v-icon>
                    BAIXAR
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom v-if="showBtn(['Diretor', 'Administrador'])">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" dark class="white--text">
                    <v-icon color="red" @click="deletarUm(item)">mdi-close-circle</v-icon>
                  </v-btn>
                </template>
                <span>Remover Atividade</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn :loading="carregandoAtv" :disabled="carregandoAtv" icon v-on="on" class="white--text">
                    <v-icon color="orange" @click="visualizar(item)">mdi-file-pdf</v-icon>
                  </v-btn>
                </template>
                <span>Baixar atividade</span>
              </v-tooltip>
              <v-tooltip bottom v-if="showBtn(['Diretor', 'Administrador'])">
                <template v-slot:activator="{ on }">
                  <v-btn :loading="carregandoAtv" :disabled="carregandoAtv" icon v-on="on" class="white--text">
                    <v-icon color="blue" @click="abriEscolasDaAtv(item)">apartment</v-icon>
                  </v-btn>
                </template>
                <span>Escolas</span>
              </v-tooltip>

            </template>

          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer />
          <v-btn color="red" dark @click="fechar">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mostrarEscolas" min-width="290" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Escolas</v-card-title>
        <v-divider />
        <v-card-text class="mt-5">
          <v-row>
            <v-select v-model="escolasSelecionadas" :items="escolasParaSelecao" item-text="nome"
              prepend-icon="apartment" return-object chips outlined dense label="Escolas" multiple>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.nome }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ escolasSelecionadas.length - 1 }} outros)
                </span>
              </template>

              <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="toggle">
                  <v-list-item-action>
                    <v-icon :color="escolasSelecionadas.length > 0 ? 'blue' : 'blue'">
                      {{ icon() }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="error" text @click="mostrarEscolas = false">CANCELAR</v-btn>
          <v-btn :loading="atualizandoEscolas" :disabled="escolasSelecionadas.length < 1" color="green darken-1" text
            @click="atualizarEscolasDaAtv()">SALVAR</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CONFIRM DIALOG -->
    <v-dialog v-model="confirmDialog" min-width="290" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">{{ mensagem }}</v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn :disabled="deletando" color="error" text @click="confirmDialog = false">CANCELAR</v-btn>
          <v-btn :loading="deletando" color="green darken-1" text @click="confirmFunction">ACEITAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- CONFIRM DIALOG -->
  </div>
</template>

<script>

import AtividadeComplementarService from "@/service/AtividadeComplementarService";
import ArquivoService from "@/service/ArquivoService";
import { mapGetters } from "vuex";

export default {
  name: "ListaAtividades",
  components: {},
  props: {
    show: Boolean,
    anoEscolar: Object,
    fechar: Function
  },

  data() {
    return {

      mostrarEscolas: false,
      escolasParaSelecao: [],
      escolasSelecionadas: [],
      carregandoEscolas: false,
      atualizandoEscolas: false,
      idAtividadeComplementar: null,

      carregandoDados: false,
      atividades: [],
      atividadesSelecionadas: [],
      search: "",
      footerProps: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [10, 20, 50]
      },
      showPdf: false,
      ArrayBuffer: "",
      headers: [
        {
          text: 'Atividade',
          value: 'descricao',
          align: 'center'
        },
        {
          text: '#',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],

      mensagem: "",
      confirmDialog: false,
      confirmando: false,
      confirmFunction: null,

      atividadesParaDeletar: "",
      success: false,
      error: false,
      deletando: false,
      carregandoAtv: false,

    }
  },
  computed: {
    ...mapGetters({
      user: 'Login/user'
    })
  },

  methods: {

    showBtn(item) {
      return item.includes(this.user ? this.user.perfil : '');
    },

    icon() {
      if (this.escolasSelecionadas.length == this.escolasParaSelecao.length) return 'mdi-close-box'
      if (this.escolasSelecionadas.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    toggle() {
      this.$nextTick(() => {
        if (this.escolasSelecionadas.length == this.escolasParaSelecao.length) {
          this.escolasSelecionadas = []
        } else {
          this.escolasSelecionadas = this.escolasParaSelecao.slice()
        }
      })
    },

    abriEscolasDaAtv(item) {
      this.idAtividadeComplementar = item.id;
      this.escolasSelecionadas = []
      this.getEscolasDaAtividade();
      this.mostrarEscolas = true;
    },

    atualizarEscolasDaAtv() {
      this.atualizandoEscolas = true
      let body = {
        idAtividadeComplementar: this.idAtividadeComplementar,
        escolas: this.escolasSelecionadas
      }

      AtividadeComplementarService.atualizarEscolasDaAtv(body)
        .finally(() => {
          this.atualizandoEscolas = false;
          this.mostrarEscolas = false;
        })

    },

    getEscolas() {
      AtividadeComplementarService.getEscolasParaSelecao()
        .then(({ data }) => {
          this.escolasParaSelecao = data;
        });
    },

    visualizar(item) {
      this.carregandoAtv = true;
      AtividadeComplementarService.getAtividade(item.id)
        .then(({ data }) => {
          let byte = ArquivoService.base64ToArrayBuffer(data);
          this.saveByteArray(item.descricao, byte, item.contentType)
        })
        .finally(() => {
          this.carregandoAtv = false;
        });
    },

    visualizarTodos() {
      this.carregandoAtv = true;
      let ids = this.getAtividadeIds();
      AtividadeComplementarService.getListaAtividades(ids)
        .then(({ data }) => {
          let byte = ArquivoService.base64ToArrayBuffer(data);
          this.saveByteArray('Atividades', byte, 'application/pdf')
          //this.showAtv(data);
        })
        .finally(() => {
          this.carregandoAtv = false;
        });
    },

    saveByteArray(reportName, byte, type) {
      var blob = new Blob([byte], { type: type });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },

    showAtv(pdf) {
      var dataURI = "data:application/pdf;base64," + pdf;
      var iframe = "<iframe width='100%' height='100%' src='" + dataURI + "'></iframe>"
      var x = window.open();

      x.document.open();
      x.document.write(iframe);
      x.document.close();
    },

    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },


    deletarUm(item) {
      let ids = [];
      ids.push(item.id);
      this.atividadesParaDeletar = ids;

      this.mensagem = `Deseja deletar a atividade?`;
      this.confirmDialog = true;
      this.confirmFunction = this.deletar;
    },

    deletarMultiplos() {
      this.atividadesParaDeletar = this.getAtividadeIds();
      this.mensagem = `Deseja deletar a atividade?`;
      this.confirmDialog = true;
      this.confirmFunction = this.deletar;
    },

    deletar() {
      this.deletando = true;
      AtividadeComplementarService.delete(this.anoEscolar.id, this.atividadesParaDeletar)
        .then(() => {
          this.getAtividades()
          this.success = true;
          this.error = false;
          this.atividadesSelecionadas = []
        })
        .catch(() => {
          this.success = false;
          this.error = true;
        })
        .finally(() => {
          this.confirmDialog = false;
          this.deletando = false;
        });
    },

    getAtividadeIds() {
      let ids = '';
      for (let i = 0; i < this.atividadesSelecionadas.length; i++) {
        ids = ids + this.atividadesSelecionadas[i].id
        if (i < this.atividadesSelecionadas.length - 1) ids += ','
      }
      return ids;
    },

    getEscolasDaAtividade() {
      AtividadeComplementarService.getEscolasDaAtividade(this.idAtividadeComplementar)
        .then(({ data }) => {
          this.escolasSelecionadas = data;
        });
    },

    getAtividades() {
      AtividadeComplementarService.getAllByAno(this.anoEscolar.id)
        .then(({ data }) => {
          this.atividades = data;
          this.atividadesSelecionadas = [];
        })
        .catch(() => {

        })
        .finally(() => {
          this.carregandoDados = false;
        })
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.carregandoDados = true;
        this.search = "";
        this.success = false;
        this.error = false;
        this.getAtividades();
        this.getEscolas();
      }
    },
  }
}
</script>